import { FC, useId } from "react";
import { createFormikFields } from "@components/forms/fields/createFormikFields";
import memberStyles from "../../memberManagement/MemberManagement.module.scss";
import styles from "./organizationTeamFields.module.scss";
import { ConfigureOrganizationPermissionsFields } from "./ConfigureOrganizationPermissionsFields";
import {
    AddOrganizationMemberFormSchema,
    OrganizationTeamFormProps,
} from "./types";

const fields = createFormikFields<AddOrganizationMemberFormSchema>();

export const AddOrganizationTeamFields: FC<OrganizationTeamFormProps> = ({
    organization,
    workspaces,
}) => {
    const emailsTitleId = useId();

    return (
        <>
            <section className={memberStyles.section}>
                <header className={memberStyles.sectionHeader}>
                    <h6
                        id={emailsTitleId}
                        className={memberStyles.sectionTitle}
                    >
                        Email addresses
                    </h6>
                </header>

                <fields.Emails
                    name="emails"
                    aria-labelledby={emailsTitleId}
                    placeholder="Emails, comma separated"
                    className={styles.emailField}
                />
            </section>

            <ConfigureOrganizationPermissionsFields
                organization={organization}
                workspaces={workspaces}
            />
        </>
    );
};
